import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileOutOfOfficeModalComponent } from './profile-out-of-office-modal.component';
import { RadioButtonAtomModule } from './../../components/atoms/radio-button/radio-button.module';
import { ModalAtomModule } from '../../components/atoms/modal/modal.module';
import { CheckboxAtomModule } from '../../components/atoms/checkbox/checkbox.module';
import { SelectAtomModule } from '../../components/atoms/select/select.module';
import { InputAtomModule } from '../../components/atoms/input/input.module';
import { ButtonAtomModule } from '../../components/atoms/button/button.module';
import { DatePickerAtomModule } from '../../components/atoms/date-picker/date-picker.module';
import { TimePickerModule } from 'src/app/components/atoms/time-picker/time-picker.module';


@NgModule({
  declarations: [ProfileOutOfOfficeModalComponent],
  imports: [
    CommonModule,
    RadioButtonAtomModule,
    ModalAtomModule,
    DatePickerAtomModule,
    CheckboxAtomModule,
    SelectAtomModule,
    InputAtomModule,
    ButtonAtomModule,
    TimePickerModule
  ],
  exports: [ProfileOutOfOfficeModalComponent]
})
export class ProfileOutOfOfficeModalModule { }
